import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
} from '@angular/core';
import { MapsAPILoader } from '@macs-frontend/core/services/maps-api-loader.service';

@Directive({
  selector: '[mdMapSearch]',
})
export class MapSearchDirective {
  @Input() radius = 10000;
  @Input() highAccuracy = false;

  @Output() placeChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private el: ElementRef,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
  ) {
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement, {
        strictBounds: false,
        fields: ['geometry', 'id', 'name', 'formatted_address'],
      });

      if (navigator.geolocation) {
        const positionOptions: PositionOptions = {
          enableHighAccuracy: this.highAccuracy,
          timeout: 15000,
          maximumAge: 0,
        };
        navigator.geolocation.getCurrentPosition(
          position => {
            const geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            const accuracy =
              position.coords.accuracy < this.radius
                ? this.radius
                : position.coords.accuracy;
            const circle = new google.maps.Circle({
              center: geolocation,
              radius: accuracy,
            });
            const bounds = circle.getBounds();
            if (bounds) {
              autocomplete.setBounds(bounds);
            }
          },
          null,
          positionOptions,
        );
      }

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.placeChange.emit(place);
        });
      });
    });
  }
}
